import React, { useContext } from 'react';
import { getContext } from 'common';
import { ListContext } from './List';

import Styled from './styles';

export interface ListGroupHeadingProps extends React.ComponentPropsWithRef<'div'> {
  /** Children. Consider using `Typography` component or plain text. */
  children: React.ReactNode;
}

/** All other props will be provided to the wrapper element. */
const ListGroupHeading = React.forwardRef<HTMLElement, ListGroupHeadingProps>((props: ListGroupHeadingProps, ref) => getContext(({ RTL }) => {
  const {
    children,
    ...otherProps
  } = props;
  const listContext = useContext(ListContext);
  return (
    <Styled.ListGroupHeading
      ref={ref}
      RTL={RTL}
      $theme={listContext.theme}
      role="presentation"
      stickyHeader={listContext.stickyHeader}
      {...otherProps}
    >
      {children}
    </Styled.ListGroupHeading>
  );
}));

ListGroupHeading.displayName = 'ListGroupHeading';


export default ListGroupHeading;
